import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/components/pages/Home.vue";
import Error404 from "@/components/pages/Error404.vue";

Vue.use(VueRouter);
const name = "Gerador de QRCode - MRX Websites";

const routes = [
  {
    path: "/",
    name,
    component: Home
  },
  {
    name: "Error404",
    path: "/error404",
    component: Error404
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      next("/error404");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach(to => {
  document.title = to.name;
  window.scrollTo(0, 0);
});

export default router;
